<script setup lang="ts">
import { ReserveType } from '@utils/itinerary';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const taxiForm = useTaxiForm();
const form = useTripSearchForm(isChangeSearch);
onMounted(() => {
    if (!isChangeSearch && form.origin.value && !taxiForm.destinations.length) {
        taxiForm.loadDestinations();
        taxiForm.loadPrices();
    }
});
watch(form.origin, () => taxiForm.loadDestinations());
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :loading
        :is-change-search
        :reserve-type="ReserveType.Taxi"
        origin-title="ایستگاه مبدأ"
        destination-title="ایستگاه مقصد"
    />
</template>
